import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL + 'api/v1/auth';

// Motivos con los que `validateToken` rechaza (`error.code`), para que quien
// la llama decida: NO_TOKEN e INVALID piden iniciar sesion de nuevo; NETWORK
// significa que no se pudo verificar (red caida, 5xx) y no es culpa del usuario.
export const AUTH_ERRORS = {
    NO_TOKEN : 'NO_TOKEN',
    INVALID  : 'INVALID',
    NETWORK  : 'NETWORK'
};

// Un token ya validado no se vuelve a consultar al servidor durante este tiempo.
export const VALIDATION_TTL_MS = 5 * 60 * 1000;

const authError = (code, cause) => Object.assign(new Error(code), { code, cause });

const readStoredUser = () => {
    try {
        return JSON.parse(localStorage.getItem('user'));
    } catch (error) {
        return null;
    }
};

class  AuthService {
    constructor(){
        // { token, until } del ultimo token que el servidor dio por bueno.
        this.validated = null;
    }

    login(user){
        return axios.post(API_URL +'/signin',{
            username : user.username,
            password : user.password
        })
        .then( response => {
            if(response.data.accessToken){
                localStorage.setItem('user',JSON.stringify(response.data));
                // Acaba de emitirlo el servidor: no hace falta validarlo de inmediato.
                this.validated = {
                    token : response.data.accessToken,
                    until : Date.now() + VALIDATION_TTL_MS
                };
            }
            return response.data;
        });
    }

    logout(){
        localStorage.removeItem('user');
        this.validated = null;
    }

    register( user ){
        return axios.post(API_URL + '/signup' , {
            username    : user.username,
            email       : user.email,
            password    : user.password
        });
    }

    // Resuelve con el usuario guardado si el token es valido. Rechaza con un
    // error cuyo `code` es uno de AUTH_ERRORS. Si el servidor rechaza el token
    // (401/403) tambien borra la sesion guardada.
    async validateToken(){
        const user = readStoredUser();
        if(!user || !user.accessToken){
            throw authError(AUTH_ERRORS.NO_TOKEN);
        }

        const validated = this.validated;
        if(validated && validated.token === user.accessToken && validated.until > Date.now()){
            return user;
        }

        try {
            // axios rechaza cualquier respuesta que no sea 2xx.
            await axios.post(API_URL + '/validate-token', {
                token : user.accessToken
            });
        } catch (error) {
            const status = error.response && error.response.status;
            if(status === 401 || status === 403){
                this.logout();
                throw authError(AUTH_ERRORS.INVALID, error);
            }
            throw authError(AUTH_ERRORS.NETWORK, error);
        }

        this.validated = {
            token : user.accessToken,
            until : Date.now() + VALIDATION_TTL_MS
        };
        return user;
    }

}
export default new AuthService();